import Glide from '@glidejs/glide';

export default {
  init() {
    // JavaScript to be fired on the about us page

    let glide = document.querySelector('.glide');
      if (glide) {
        let pg = new Glide(glide, {
          type: 'carousel',
        });

        let index = pg.index;
      
        let arrows = glide.querySelectorAll('[data-arrow-dir]');
        arrows.forEach(a => {
          a.addEventListener('click', () => {
            pg.go(a.dataset.glideDir);
          });
        });
      
        pg.on('move.after', () => {
          if (index != pg.index) {
            document.querySelectorAll('.glide__slide video').forEach(v => {
              v.pause();
            });
          }

          index = pg.index;
        });
        
        pg.mount();
      }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single.js